// extracted by mini-css-extract-plugin
export default {"body":"SpaceMoveDeviceModal_body__+KLbu","modalHeight":"SpaceMoveDeviceModal_modalHeight__LxrRb"};